import React from "react";
import { Row, Col } from "reactstrap";

import logo from "../../assets/images/logos/moore-logo-black.png";

const Header = (props: any) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <img src={logo} alt="logo" width="120px" />
        </Col>
        <Col>
          <h1 style={{ color: "#c8222a", fontSize: "28px", textAlign: "right" }}>MOORE BV / SRL</h1>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Header;
